import { render, staticRenderFns } from "./GuestsDeleteGuest.vue?vue&type=template&id=0cba23de&"
import script from "./GuestsDeleteGuest.vue?vue&type=script&lang=js&"
export * from "./GuestsDeleteGuest.vue?vue&type=script&lang=js&"
import style0 from "./GuestsDeleteGuest.vue?vue&type=style&index=0&id=0cba23de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports